import { Pagination } from './paginations';

export interface InternetAddress {
	readonly emailAddress: string;
	readonly personal: string | null;
}

export enum NotificationPriority {
	NORMAL = 'normal',
	HIGH = 'high',
}

export interface GenericAuthenticatedRecipient<Date> {
	readonly priority: NotificationPriority;
	readonly readTime: Date | null;
}

export enum StatusEnum {
	CREATED = 'created',
	SENT = 'sent',
	FAILED = 'failed',
}

export interface NotificationEmailAttachments {
	readonly fileName: string;
	readonly id: string;
}

export interface NotificationEmail {
	readonly attachments: NotificationEmailAttachments[];
	readonly bcc: InternetAddress[];
	readonly cc: InternetAddress[];
	readonly externalId: string;
	readonly from: InternetAddress;
	readonly id: string;
	readonly replyTo: InternetAddress;
	readonly status: StatusEnum;
	readonly subject: string;
	readonly to: InternetAddress[];
}

export interface NotificationRecipients {
	readonly email: string;
	readonly externalId: string;
	readonly phoneNumber: string;
}

export interface GenericNotification<Date> {
	readonly authenticatedRecipient: GenericAuthenticatedRecipient<Date>;
	readonly canceledTime: Date | null;
	readonly createdTime: Date;
	readonly deduplicationId: string;
	readonly email: NotificationEmail | null;
	readonly externalId: string;
	readonly id: string;
	readonly notificationTypeId: string;
	readonly perex: string | null;
	readonly recipients: NotificationRecipients[];
	readonly sender: string;
}

export type Notification = GenericNotification<Date>;

export type AuthenticatedRecipient = GenericAuthenticatedRecipient<Date>;

export interface NotificationResponse {
	readonly notification: Notification;
}

export interface Stats {
	highPriority?: number;
	unread?: number;
}

export interface NotificationsResponse {
	readonly items: Notification[];
	readonly pagination: Pagination;
	readonly stats: Stats;
}

export interface EncodedNotificationResponse {
	readonly notification: GenericNotification<string>;
}

export enum NotificationError {
	notFound = 'notification-not-found',
}

export interface NotificationsDetailResponse {
	data: HTMLDivElement;
}
